import { Card, CardHeader, CardTitle, CardDescription, CardContent, Switch } from '../../components/ui';
import { motion } from 'framer-motion';
import { useTheme } from '@/core/ThemeContext';

export function AppearanceSection() {
  const { theme, setTheme } = useTheme();

  const handleThemeChange = (checked: boolean) => {
    setTheme(checked ? 'dark' : 'light');
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.2 }}
    >
      <Card variant="elevated" padding="lg">
        <CardHeader>
          <CardTitle>Appearance</CardTitle>
          <CardDescription>Customize how the app looks</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-900 dark:text-white">
                  Dark Mode
                </p>
                <p className="text-xs text-gray-600 dark:text-slate-400">
                  Use dark theme across the app
                </p>
              </div>
              <Switch
                checked={theme === 'dark'}
                onChange={(e) => handleThemeChange(e.target.checked)}
                data-testid="theme-toggle"
              />
            </div>
          </div>
        </CardContent>
      </Card>
    </motion.div>
  );
}
